import { call, put, takeLatest } from 'redux-saga/effects';
import {
  OPEN_PLATFORM_APP_LEARN_MORE_PAGE_REQUEST,
  OPEN_PLATFORM_APP_LEARN_MORE_ON_CHANGE_FIELD,
} from 'actions/openPlatform/appLearnMore/constants';
import * as apiMarketplaces from 'api/marketplaces';
import * as actAppLearnMore from 'actions/openPlatform/appLearnMore';
import { push } from 'react-router-redux';

export function* pageRequestFlow(request) {
  yield put(actAppLearnMore.reset());
  const {
    payload: { id },
  } = request;

  const response = yield call(apiMarketplaces.getAppDetail, { id });

  yield put(actAppLearnMore.setApp({ app: response.data.data.app }));
}

export function* onChangeRequest(request) {
  yield put(
    push({
      pathname: '/apps/app-market',
      state: { params: request.payload },
    })
  );
}

export default function* saga() {
  yield takeLatest(OPEN_PLATFORM_APP_LEARN_MORE_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(
    OPEN_PLATFORM_APP_LEARN_MORE_ON_CHANGE_FIELD,
    onChangeRequest
  );
}
